import { render, staticRenderFns } from "./modal_graficos.vue?vue&type=template&id=54c3a957&scoped=true&"
import script from "./modal_graficos.vue?vue&type=script&lang=js&"
export * from "./modal_graficos.vue?vue&type=script&lang=js&"
import style0 from "./modal_graficos.vue?vue&type=style&index=0&id=54c3a957&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3a957",
  null
  
)

export default component.exports